interface Props {
  title?: string;
  message?: string;
  onClose: () => void;
  buttonLabel?: string;
}

const FormSuccess = ({
  title = "Message Sent!",
  message = "Thank you for reaching out. Our team will get back to you within 24 hours.",
  onClose,
  buttonLabel = "Done",
}: Props) => {
  return (
    <div className="flex flex-col items-center justify-center gap-6 py-12 px-8 text-center">
      {/* Animated checkmark circle */}
      <div className="relative flex items-center justify-center w-24 h-24">
        <div className="absolute inset-0 rounded-full bg-[#CBA135]/10 animate-ping" />
        <div className="relative flex items-center justify-center w-24 h-24 rounded-full bg-[#CBA135]/15 border-2 border-[#CBA135]">
          <svg
            className="w-10 h-10 text-[#CBA135]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-bold text-[#1A1A2E]">{title}</h2>
        <p className="text-sm text-[#6B6B6B] max-w-xs leading-relaxed">
          {message}
        </p>
      </div>

      <button
        onClick={onClose}
        className="h-12 px-10 rounded-full bg-[#CBA135] text-[#1A1A2E] font-semibold text-sm transition-opacity hover:opacity-90"
      >
        {buttonLabel}
      </button>
    </div>
  );
};

export default FormSuccess;
